import { Container, Row, Col, Media, Modal, Button } from 'react-bootstrap'
import ModalTvc from "../tvc/ModalTvc"
import { useState } from 'react'

function TvcWorkbook (props) {

const [lgShow, setLgShow] = useState(false);

return (
<div>
	<div className="tvc__workBook">
		<Container>
			<Row>
				<Col lg={7} md={12}>
				<div className="">
					<p className="tvc__workBook--title pt-2"><strong>Download this free helpful checklist</strong> <br />
						and learn the right questions to ask when buying your next vitamin supplement.
					</p>
					<div className="mt-4 mb-5">
						<Button variant="link" onClick={() => setLgShow(true)}>
						<a className=" text-dark">Get the Checklist</a></Button>
					</div>
					<Modal
						size="lg"
						show={lgShow}
						onHide={() =>
						setLgShow(false)}
						aria-labelledby="example-modal-sizes-title-lg"
						>
						<ModalTvc global={props.global}/>
					</Modal>
				</div>
				<Media className="ml-5">
					<img className="tvc__workBook--erica mr-3" src="../images/tvc/img-testimonial-erika-cohen01.png" alt="Erica Cohen" />
					<Media.Body>
						<p className="tvc__workBook--testimony"><em>&quot;This surely helps to choose what to look for in a good supplement. Thank you&quot;</em>
							<br />
							<em><strong>- Erika Cohen</strong></em>
						</p>
					</Media.Body>
				</Media>
				</Col>
				<Col lg={5} md={12}>
				<img className="tvc__workBook-img img-fluid mr-3" src="../images/tvc/img-download-free-ebook01.png" alt="Ebook" /></Col>
			</Row>
		</Container>
	</div>
	<style jsx global>{`
		.tvc__workBook .btn{
			font-size: 1.5rem;
			text-decoration: underline;
		}
		@media(max-width: 991px){
			.tvc__workBook .media{
				margin-left: 0px!important;
			}
		}
		`}
	</style>
	<style jsx>{`
		.tvc__workBook{
			padding: 100px 15px 30px;
		}
		.tvc__workBook--title{
			line-height: 1.5;
			font-size: 1.5rem;
		}
		.tvc__workBook--text{
			font-size: 1.5rem;
			text-decoration: underline;
		}
		p.tvc__workBook--testimony{
			font-size: 1.2rem;
		}
			@media(max-width: 991px){
				.tvc__workBook-img{
					display: block;
					margin:3rem auto;
				}
			}
		`}
	</style>
</div>
);
}
export default TvcWorkbook;